export const SEARCH_TABS = {
  ALL: "all",
  PROFILES: "profiles",
  HASHTAGS: "hashtags",
  CHALLENGES: "challenges",
  VIDEOS: "videos",
};
